module.exports = __webpack_public_path__ + "static/img/point-icon-img@t.7b638bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/point-icon-img@t.png
// module id = kfAk
// module chunks = 0